import { useRouteParams as useRouteParamsBase } from '../../_hooks/useRouteParams';

export type TabSlug = 'allocations' | 'trades' | 'confirmations';

export interface RouteParams {
  tabSlug: TabSlug;
}

export const useRouteParams = () => {
  return useRouteParamsBase<RouteParams>();
};
